// src/components/Nav/Nav.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Rocket } from "lucide-react";
import ThemeToggle from "./ThemeToggle.jsx";
import "./nav.css";
import logo from "../../logos/matchededgegrey.png";
import SearchBar from "../ui/SearchBar.jsx";

const Nav = () => {
  const handleNavClick = () => {
    console.log("Search result clicked, closing search results / sidebar.");
  };

  return (
    <nav className="fixed-nav">
      <div className="nav-left">
        <Link to="/">
          <img src={logo} alt="Matched Edge Logo" />
        </Link>
        <Link to="/get-started/step1" className="nav-link start-button">
          <Rocket size={20} style={{ marginRight: "8px" }} />
          <p>Start here</p>
        </Link>
      </div>
      <div className="nav-right">
        <SearchBar autoClose={true} onResultClick={handleNavClick} />
        <Link to="/guides" className="nav-link right">
          Guides
        </Link>
        <Link to="/calculators" className="nav-link right">
          Calculators
        </Link>
        <Link to="/faqs" className="nav-link right">
          FAQs
        </Link>
        <ThemeToggle />
      </div>
    </nav>
  );
};

export default Nav;
